// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import type {
  ChangeFeatureStatusData,
  ChangeFeatureStatusErrors,
  ChangeFeatureStatusResponses,
  CreateSimulationData,
  CreateSimulationErrors,
  CreateSimulationResponses,
  DatabaseInfoData,
  DatabaseInfoErrors,
  DatabaseInfoResponses,
  DeleteSimulationData,
  DeleteSimulationErrors,
  DeleteSimulationResponses,
  DoWorkData,
  DoWorkErrors,
  DoWorkResponses,
  EventsData,
  EventsErrors,
  EventsResponses,
  GenerateDataData,
  GenerateDataErrors,
  GenerateDataResponses,
  GetAnalyticsData,
  GetAnalyticsErrors,
  GetAnalyticsResponses,
  GetFeatureFlagsData,
  GetFeatureFlagsErrors,
  GetFeatureFlagsResponses,
  GetFeaturesData,
  GetFeaturesErrors,
  GetFeaturesResponses,
  GetFeatureTasksData,
  GetFeatureTasksErrors,
  GetFeatureTasksResponses,
  GetSimulationByLabelData,
  GetSimulationByLabelErrors,
  GetSimulationByLabelResponses,
  GetSimulationData,
  GetSimulationErrors,
  GetSimulationResponses,
  GetTaskData,
  GetTaskErrors,
  GetTaskResponses,
  GetTasksData,
  GetTasksErrors,
  GetTasksResponses,
  GetTeamsData,
  GetTeamsErrors,
  GetTeamsResponses,
  HealthData,
  HealthResponses,
  ListSimulationsData,
  ListSimulationsErrors,
  ListSimulationsResponses,
  PatchSimulationData,
  PatchSimulationErrors,
  PatchSimulationResponses,
  ResetDatabaseData,
  ResetDatabaseErrors,
  ResetDatabaseResponses,
  SetFeatureFlagsData,
  SetFeatureFlagsErrors,
  SetFeatureFlagsResponses,
} from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<
  TData,
  ThrowOnError
> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

export const databaseInfo = <ThrowOnError extends boolean = false>(options?: Options<DatabaseInfoData, ThrowOnError>) =>
  (options?.client ?? client).get<DatabaseInfoResponses, DatabaseInfoErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/admin/database-info',
    ...options,
  });

export const generateData = <ThrowOnError extends boolean = false>(options: Options<GenerateDataData, ThrowOnError>) =>
  (options.client ?? client).post<GenerateDataResponses, GenerateDataErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/admin/generate-data',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const resetDatabase = <ThrowOnError extends boolean = false>(
  options?: Options<ResetDatabaseData, ThrowOnError>,
) =>
  (options?.client ?? client).post<ResetDatabaseResponses, ResetDatabaseErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/admin/reset-database',
    ...options,
  });

export const health = <ThrowOnError extends boolean = false>(options?: Options<HealthData, ThrowOnError>) =>
  (options?.client ?? client).get<HealthResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/health',
    ...options,
  });

export const listSimulations = <ThrowOnError extends boolean = false>(
  options?: Options<ListSimulationsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ListSimulationsResponses, ListSimulationsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/simulations',
    ...options,
  });

export const createSimulation = <ThrowOnError extends boolean = false>(
  options: Options<CreateSimulationData, ThrowOnError>,
) =>
  (options.client ?? client).post<CreateSimulationResponses, CreateSimulationErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/simulations',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const getSimulationByLabel = <ThrowOnError extends boolean = false>(
  options: Options<GetSimulationByLabelData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetSimulationByLabelResponses, GetSimulationByLabelErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/simulations/by-label/{label}',
    ...options,
  });

export const deleteSimulation = <ThrowOnError extends boolean = false>(
  options: Options<DeleteSimulationData, ThrowOnError>,
) =>
  (options.client ?? client).delete<DeleteSimulationResponses, DeleteSimulationErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/simulations/{sim_id}',
    ...options,
  });

export const getSimulation = <ThrowOnError extends boolean = false>(
  options: Options<GetSimulationData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetSimulationResponses, GetSimulationErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/simulations/{sim_id}',
    ...options,
  });

export const patchSimulation = <ThrowOnError extends boolean = false>(
  options: Options<PatchSimulationData, ThrowOnError>,
) =>
  (options.client ?? client).patch<PatchSimulationResponses, PatchSimulationErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/simulations/{sim_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const getAnalytics = <ThrowOnError extends boolean = false>(options: Options<GetAnalyticsData, ThrowOnError>) =>
  (options.client ?? client).get<GetAnalyticsResponses, GetAnalyticsErrors, ThrowOnError>({
    responseType: 'text',
    url: '/api/simulations/{sim_id}/analytics',
    ...options,
  });

export const events = <ThrowOnError extends boolean = false>(options: Options<EventsData, ThrowOnError>) =>
  (options.client ?? client).sse.get<EventsResponses, EventsErrors, ThrowOnError>({
    responseType: 'text',
    url: '/api/simulations/{sim_id}/events',
    ...options,
  });

export const getFeatureFlags = <ThrowOnError extends boolean = false>(
  options: Options<GetFeatureFlagsData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetFeatureFlagsResponses, GetFeatureFlagsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/simulations/{sim_id}/feature-flags',
    ...options,
  });

export const setFeatureFlags = <ThrowOnError extends boolean = false>(
  options: Options<SetFeatureFlagsData, ThrowOnError>,
) =>
  (options.client ?? client).patch<SetFeatureFlagsResponses, SetFeatureFlagsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/simulations/{sim_id}/feature-flags',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const getFeatures = <ThrowOnError extends boolean = false>(options: Options<GetFeaturesData, ThrowOnError>) =>
  (options.client ?? client).get<GetFeaturesResponses, GetFeaturesErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/simulations/{sim_id}/features',
    ...options,
  });

export const changeFeatureStatus = <ThrowOnError extends boolean = false>(
  options: Options<ChangeFeatureStatusData, ThrowOnError>,
) =>
  (options.client ?? client).patch<ChangeFeatureStatusResponses, ChangeFeatureStatusErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/simulations/{sim_id}/features/{feature_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const getFeatureTasks = <ThrowOnError extends boolean = false>(
  options: Options<GetFeatureTasksData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetFeatureTasksResponses, GetFeatureTasksErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/simulations/{sim_id}/features/{feature_id}/tasks',
    ...options,
  });

export const getTasks = <ThrowOnError extends boolean = false>(options: Options<GetTasksData, ThrowOnError>) =>
  (options.client ?? client).get<GetTasksResponses, GetTasksErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/simulations/{sim_id}/tasks',
    ...options,
  });

export const getTask = <ThrowOnError extends boolean = false>(options: Options<GetTaskData, ThrowOnError>) =>
  (options.client ?? client).get<GetTaskResponses, GetTaskErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/simulations/{sim_id}/tasks/{task_id}',
    ...options,
  });

export const doWork = <ThrowOnError extends boolean = false>(options: Options<DoWorkData, ThrowOnError>) =>
  (options.client ?? client).post<DoWorkResponses, DoWorkErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/simulations/{sim_id}/tasks/{task_id}/do-work',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const getTeams = <ThrowOnError extends boolean = false>(options: Options<GetTeamsData, ThrowOnError>) =>
  (options.client ?? client).get<GetTeamsResponses, GetTeamsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/simulations/{sim_id}/teams',
    ...options,
  });
